'use client';

import { createContext } from 'app/libs/createContext';
import { type UseNavigationReturn } from './useNavigation';

export const [NavigationProvider, useNavigationContext, NavigationContext] =
    createContext<UseNavigationReturn>({
        name: 'NavigationContext',
    });
